import React from 'react';

export const NextjsLogo = () => {
  return (
    <svg
      className="stack-icons"
      id="uuid-b4df3068-4bc4-48b1-976d-0778e7b4269a"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
    >
      <g id="uuid-0de595d5-c861-417a-8dee-1d19c977f9ca">
        <circle cx="49.9" cy="49.9" r="49.9" fill="#ebebeb" />
      </g>
      <g id="uuid-29a4a550-4fba-4f0d-b0d9-35ec2a262bbc">
        <g id="uuid-46ecefab-fd96-437c-a22c-9c6bc09b6387">
          <g
            id="uuid-4dd2abbe-92b4-4927-af6e-e1436715facc"
            transform="translate(-247.000000, -138.000000)"
          >
            <g
              id="uuid-777126bd-b69d-4839-b47d-028a88d1e6d3"
              transform="translate(247.000000, 138.000000)"
            >
              <g id="uuid-5b1de224-8682-4744-80d1-7b7c3ae492f7">
                <path
                  id="uuid-4ad79f2b-b54e-48c1-8b62-20ff54a7ca47"
                  d="M34.2,39.6h13.9v1.1h-12.6v8.3h11.9v1.1h-11.9v9.1h12.8v1.1h-14.1v-20.7Zm15.2,0h1.5l6.6,9.1,6.7-9.1,9.1-11.6-15,21.6,7.7,10.6h-1.5l-7-9.7-7,9.7h-1.5l7.8-10.6-7.3-10.1Zm17.1,1.1v-1.1h15.9v1.1h-7.3v19.6h-1.3v-19.6h-7.3Z"
                />
                <polygon
                  id="uuid-fc9d1011-5e49-4207-8106-b71b3d1fe890"
                  points="16.7 39.6 18.3 39.6 40.3 72.4 31.2 60.3 18.1 41.2 18 60.3 16.7 60.3 16.7 39.6"
                />
              </g>
              <path
                id="uuid-e1fb314a-5f78-4fe6-b015-561dfb91df5f"
                d="M82.2,58.9c.3,0,.5-.2,.5-.5s-.2-.5-.5-.5-.5,.2-.5,.5,.2,.5,.5,.5Zm1.3-1.2c0,.8,.6,1.3,1.4,1.3s1.4-.5,1.4-1.4v-3.2h-.7v3.2c0,.5-.3,.8-.7,.8s-.7-.2-.7-.6h-.7Zm3.7,0c0,.8,.7,1.3,1.7,1.3s1.7-.5,1.7-1.4-.4-1-1.3-1.3h-.5c-.6-.3-.8-.4-.8-.8s.4-.7,.9-.7,.9,.3,.9,.7h.7c0-.8-.7-1.3-1.6-1.3s-1.6,.5-1.6,1.3,.4,1,1.2,1.2h.6c.6,.3,.9,.5,.9,.8s-.4,.7-1,.7-1-.3-1.1-.7h-.7Z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
